import { useListServiceCategorysForAccountQuery } from "@generated";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";

const useListServiceCategories = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data, error, isLoading, refetch } =
    useListServiceCategorysForAccountQuery(
      { slug: accountSlug },
      { skip: !accountSlug }
    );

  return {
    serviceCategories: data?.data || [],
    error,
    isLoading,
    refetch,
  };
};

export default useListServiceCategories;
